import React, { useEffect } from "react";

const Header = () => {
  useEffect(() => {
    const header = document.querySelector("#header");
    const navMenu = document.querySelector("body");
    const toggleBtn = document.querySelector(".mobile-nav-toggle");

    if (!header || !navMenu || !toggleBtn) return;

    // open / close mobile nav
    const toggleMenu = () => {
      navMenu.classList.toggle("mobile-nav-active");
      toggleBtn.classList.toggle("bi-list");
      toggleBtn.classList.toggle("bi-x");
    };
    toggleBtn.addEventListener("click", toggleMenu);

    // dropdowns inside mobile view
    const dropdownLinks = navMenu.querySelectorAll(".dropdown > a");
    dropdownLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        if (navMenu.classList.contains("mobile-nav-active")) {
          e.preventDefault();
          link.nextElementSibling.classList.toggle("dropdown-active");
          const icon = link.querySelector(".toggle-dropdown");
          if (icon) icon.classList.toggle("bi-chevron-up");
        }
      });
    });

    return () => {
      toggleBtn.removeEventListener("click", toggleMenu);
      dropdownLinks.forEach((link) =>
        link.replaceWith(link.cloneNode(true))
      );
    };
  }, []);

  return (
    <header
      id="header"
      className="header d-flex align-items-center sticky-top"
    >
      <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
        <a
          href="#hero"
          className="logo d-flex align-items-center me-auto me-xl-0"
        >
          <h1 className="sitename">Autobotics</h1>
        </a>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <a href="#hero" className="active">
                Home
              </a>
            </li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            {/* <li><a href="#portfolio">Portfolio</a></li> */}
            <li><a href="#contact">Contact</a></li>
          </ul>
          <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

        <a className="btn-getstarted btn btn-primary" href="#about">
          Get Started
        </a>
      </div>
    </header>
  );
};

export default Header;
